import classnames from "classnames";
import React, { FunctionComponent, memo } from "react";

import { Anchor as EworkitAnchor, IAnchorProps as IAnchor } from "@/eworkitComponents";
import { buildTextAlignClassName, TTextAlign } from "@/style/textAlign";

import "./_anchor.scss";

export interface IAnchorProps extends IAnchor {
  align?: TTextAlign;
}
/**
 * @deprecated Use iris-based implementation instead.
 */
export const Anchor: FunctionComponent<IAnchorProps> = memo(({ align, className, ...props }) => (
  <EworkitAnchor className={classnames(buildTextAlignClassName(align), className)} {...props} />
));
